import React from "react";
import _ from "lodash";

function Separator({ turns, style }) {
    return (
        <div
            style={{
                position: "absolute",
                height: "100%",
                transform: `rotate(${turns}turn)`
            }}
        >
            <div style={style} />
        </div>
    );
}

function RadialSeparatorsCalls({ count, style, circleRatio }) {
    const turns = circleRatio / count; // Calculate the spacing for the separators
    const offset = 0.5; // Offset to align the separators correctly (10 AM start)

    return _.range(count).map((index) => (
        <Separator
            key={index}
            turns={(index * turns) - 0.25} // Add offset to align correctly
            style={style}
        />
    ));
}


export default RadialSeparatorsCalls;